import React from 'react';
import { DataList } from 'commons-ui';

import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES } from 'constant';

import useService from '../../utils/useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { DEFAULT_CONFIG, columnConfigs } from './listConfig';

const ExperimentsList: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();

	const { getAllExperiments } = useService();

	return (
		<DataList
			fetchData={getAllExperiments}
			columnConfigs={columnConfigs}
			getActionHandler={getActionHandler}
			actions={actions}
			entity={LIST_ENTITY_NAMES.AB_TESTS}
			defaults={DEFAULT_CONFIG}
			initialSortDirection='ASC'
			initialSortIndex={1}
			searchable
			filterable
			fullDataSearch
		/>
	);
};

export default ExperimentsList;
